import styled from "styled-components";

export const ServiceCardWrapper = styled.div`
  .services_wraper {
    display: flex;
    gap: 20px;
  }

  .services_card_wrap {
    position: relative;
    width: 100%;
    max-width: calc((100% - 295px - (3 * 20px)) / 3);
    width: 100%;
    min-height: 376px;
    height: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    transition: all 0.4s ease-in-out;
    cursor: pointer;
    @media (max-width: 1199px) {
      max-width: calc((100% - 400px - (3 * 20px)) / 3);
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      max-width: 100%;
      min-height: auto;
      border-radius: 12px;
    }
    &.active {
      flex-grow: 1;
      max-width: 295px;
      @media (max-width: 1199px) {
        max-width: 400px;
      }
      @media (max-width: 899px) {
        max-width: 100%;
        min-height: 320px;
      }
      .services_card_inner {
        .description_text {
          display: block;
        }
      }
    }
    &.not_active {
      .title_text {
        max-width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .services_card {
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 100%;
      padding: 25px;

      @media (max-width: 1799px) {
        padding: 18px;
      }
    }

    .services_card_inner {
      position: relative;
      z-index: 3;
      max-width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      flex-direction: column;
      flex-shrink: 0;
      transition: all 0.4s ease-in-out;
      * {
        color: rgb(255, 255, 255);
      }

      .description_text {
        margin-top: 5px;
        display: none;
        @media (max-width: 899px) {
          display: block;
        }
      }
    }
    .services_card_bg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      user-select: none;

      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(4, 12, 31, 0.4) 0%,
          #040c1f 100%
        );
        opacity: 1;
        border-radius: 20px;
        transition: all 0.3s ease-in-out;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
